export const isWindowUserAgentCinchApp =
  typeof window !== 'undefined' &&
  window.navigator?.userAgent.includes('cinchapp')
